// ** React Imports
import { Fragment, useState, useRef } from "react"

// ** Third Party Components
import classnames from "classnames"
import PerfectScrollbar from "react-perfect-scrollbar"
import { useLocation, useNavigate } from 'react-router-dom';

// ** Vertical Menu Components
import VerticalMenuHeader from "./VerticalMenuHeader"
import VerticalNavMenuItems from "./VerticalNavMenuItems"
import { SideBarWidth } from "../../../../../StyledComponents"
import { BiLogOut } from "react-icons/bi"
import { IoSettingsOutline } from "react-icons/io5";
// import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux"
import {
  handleMenuHidden
} from "@store/layout"

import LogoutModal from "./LogoutModal"

import styles from './index.module.scss'
import classNames from "classnames";
import SwitchTo from "./SwitchTo/SwitchTo";

const Sidebar = (props) => {
  // ** Props
  const { menuCollapsed, menu, skin, menuData, isMobile } = props

  // ** States
  const [groupOpen, setGroupOpen] = useState([])
  const [groupActive, setGroupActive] = useState([])
  const [currentActiveGroup, setCurrentActiveGroup] = useState([])
  const [activeItem, setActiveItem] = useState(null)
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const layoutStore = useSelector((state) => state.layout)
  const isHidden = layoutStore.menuHidden
  const setIsHidden = () => dispatch(handleMenuHidden())

  let role = localStorage.getItem('selectedRole');
  let isCustomer = role === 'customer' ? true : false


  // ** Menu Hover State
  const [menuHover, setMenuHover] = useState(false)

  // ** Ref
  // const shadowRef = useRef(null)
  const location = useLocation()



  // ** Function to handle Mouse Enter
  const onMouseEnter = () => {
    setMenuHover(true)
  }

  const handleOpenModal = () => {
    setIsConfirmationModalOpen(true)
  }

  // ** Scroll Menu
  // const scrollMenu = (container) => {
  //   if (shadowRef && container.scrollTop > 0) {
  //     if (!shadowRef.current.classList.contains("d-block")) {
  //       shadowRef.current.classList.add("d-block")
  //     }
  //   } else {
  //     if (shadowRef.current.classList.contains("d-block")) {
  //       shadowRef.current.classList.remove("d-block")
  //     }
  //   }
  // }


  return (
    <Fragment>
      <SideBarWidth
        className={classnames(
          `main-menu menu-accordion menu-shadow`,
          {
            expanded: menuHover,
            "menu-light": skin !== "semi-dark" && skin !== "dark",
            "menu-dark": skin === "semi-dark" || skin === "dark",
            "menu-open": isHidden,
            "menu-fixed": role !== 'customer',
            "menu-fixed": role === 'admin' || role === 'wholesaler' || role === 'seller'
          },
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={() => setMenuHover(false)}
      >
        {menu ? (
          menu({ ...props })
        ) : (
          <Fragment>
            {/* Vertical Menu Header */}
            {/* <VerticalMenuHeader
              setGroupOpen={setGroupOpen}
              menuHover={menuHover}
              {...props}
            /> */}
            {/* Vertical Menu Header Shadow */}
            {isMobile &&
              (
                <div className="text-white position-absolute top-0 end-0 z-3 p-3" onClick={setIsHidden}><IoClose size={24} /></div>
              )
            }

            {/* <div className="shadow-bottom" ref={shadowRef}></div> */}
            {/* Perfect Scrollbar */}
            <PerfectScrollbar
              className="main-menu-content"
              options={{ wheelPropagation: false }}
            // onScrollY={(container) => scrollMenu(container)}
            >
              <ul className="navigation navigation-main">
                <VerticalNavMenuItems
                  items={menuData}
                  menuData={menuData}
                  menuHover={menuHover}
                  groupOpen={groupOpen}
                  activeItem={activeItem}
                  groupActive={groupActive}
                  setGroupOpen={setGroupOpen}
                  menuCollapsed={menuCollapsed}
                  setActiveItem={setActiveItem}
                  setGroupActive={setGroupActive}
                  currentActiveGroup={currentActiveGroup}
                  setCurrentActiveGroup={setCurrentActiveGroup}
                />

                {isCustomer && (
                  <>
                    <div className={styles['logout']} onClick={handleOpenModal}>
                      <div><BiLogOut size={20} className={styles['icon']} /></div>
                      <div>Logout</div>
                    </div>
                    <div className={`${styles["settings"]} d-flex gap-3 align-items-center text-white`}>
                      <div
                        className={classNames("cursor-pointer", {
                          [styles["settings-active"]]: location.pathname === "/settings",
                        })}
                        onClick={() => navigate("/settings")}
                      >
                        <IoSettingsOutline size={24} />
                      </div>

                      <SwitchTo />

                    </div>
                  </>
                )}
              </ul>
            </PerfectScrollbar>
          </Fragment>
        )
        }
      </SideBarWidth >

      <LogoutModal {...{ setIsConfirmationModalOpen, isConfirmationModalOpen }} />

    </Fragment >
  )
}

export default Sidebar
